import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import { OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Link from "@waytek/MobiusOverrides/Link/Link";
import { loadBucketsItems } from "@waytek/Utilities/global/cart";
import { fontFamilyAlt } from "@waytek/Utilities/variables";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

export interface OrderDetailsTrackingNumberStyles {
    titleText?: TypographyPresentationProps;
    trackingNumberText?: TypographyPresentationProps;
    wrapper?: InjectableCss;
}

export const paymentTermsStyles: OrderDetailsTrackingNumberStyles = {
    titleText: {
        variant: "h6",
        css: css`
            font-family: ${fontFamilyAlt};
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.71;
            letter-spacing: normal;
            margin-bottom: 5px;
        `,
    },

    trackingNumberText: {
        css: css`
            font-family: ${fontFamilyAlt};
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.71;
            letter-spacing: normal;
            display: block;
        `,
    },
};
const styles = paymentTermsStyles;
// eslint-disable-next-line
/* eslint-disable sonarjs/cognitive-complexity */
const OrderDetailsTrackingNumber = () => {
    const { value: order } = useContext(OrderStateContext);

    if (order == null) {
        return null;
    }

    const orderShippingInfo = JSON.parse(order.properties.shipmentPackageProperties);

    const { partialShipmentList, backorderedList, scheduledShipmentsList } = loadBucketsItems<OrderLineModel>(
        order.orderLines ?? [],
    );

    let noTrackingText = "Processing";
    if (scheduledShipmentsList.length > 0) {
        noTrackingText = "Scheduled per requested date";
    }
    if (partialShipmentList.length > 0) {
        noTrackingText = "Pending, Partial shipment";
    }
    if (backorderedList.length > 0) {
        noTrackingText = "Pending, Backordered";
    }
    // eslint-disable-next-line
    /* eslint-disable sonarjs/no-collection-size-mischeck */
    return (
        <StyledWrapper {...styles.wrapper}>
            {(order.shipmentPackages || []).length === 0 && (
                <Typography as="h3" {...styles.titleText}>
                    {translate("Estimated Ship Date")}
                </Typography>
            )}
            {(order.shipmentPackages || []).length === 1 && (
                <Typography as="h3" {...styles.titleText}>
                    {translate("Tracking Number")}
                </Typography>
            )}
            {(order.shipmentPackages || []).length > 1 && (
                <Typography as="h3" {...styles.titleText}>
                    {translate("Tracking Numbers")}
                </Typography>
            )}

            {(order.shipmentPackages || []).length > 0 &&
                order.shipmentPackages?.map((item, index) => {
                    if (
                        item.trackingNumber &&
                        orderShippingInfo[index].carrierTrackingUrl !== "" &&
                        orderShippingInfo[index].carrierTrackingUrl !== null
                    ) {
                        return (
                            <Link
                                key={`link_${index}`}
                                href={
                                    orderShippingInfo[index].carrierTrackingUrl +
                                    order.shipmentPackages![index].trackingNumber
                                }
                                {...styles.trackingNumberText}
                            >
                                {item.trackingNumber}
                            </Link>
                        );
                    }
                    if (
                        (item.trackingNumber && orderShippingInfo[index].carrierTrackingUrl === "") ||
                        orderShippingInfo[index].carrierTrackingUrl === null
                    ) {
                        return (
                            <Typography key={`label_${index}`} {...styles.trackingNumberText}>
                                {item.trackingNumber}
                            </Typography>
                        );
                    }
                    return <></>;
                })}

            {(order.shipmentPackages || []).length === 0 && (
                <Typography {...styles.trackingNumberText}>{noTrackingText}</Typography>
            )}
        </StyledWrapper>
    );
    // eslint-disable-next-line
    /* eslint-enable sonarjs/no-collection-size-mischeck */
};
// eslint-disable-next-line
/* eslint-enable sonarjs/cognitive-complexity */
const widgetModule: WidgetModule = {
    component: OrderDetailsTrackingNumber,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
